import {formatLocalDateTime} from '../utils/formatLocalDateTime';


export const boxForecast48 = () => {
    const getCurrentCompanyLocationId = () => {
        const idHolder = document.querySelector('#current-company-location__id');

        if (idHolder) {
            return idHolder.getAttribute('value');
        }
    }

    const getApiUrl = () => {
        return `/api/company-location/${getCurrentCompanyLocationId()}/weather-forecast/hourly`;
    }

    const currentCompany = getCurrentCompanyLocationId();

    const drawTableData = (data) => {
        console.log('data', data);
        const rainUnit = data.rainUnit;
        const windUnit = data.windUnit;
        const snowUnit = data.snowUnit;
        const [...hours] = data.hours;

        const printChartBar = (barData, dataUnit) => {
            let chartBar = '';

            if (barData) {
                const bar = barData * 20;

                chartBar = `
                    <div class="c-chart__bar" style="width: ${bar}px"></div>
                    <div class="c-chart__label">${barData} ${dataUnit}</div>
                `;
            }

            return chartBar;
        }

        const isChartBarActive = (barData) => {
            return !!(barData);
        }

        const printDateDay = (data) => {
            const curDate = formatLocalDateTime(data.hourAsLocalTimeHour);
            if(data.language == "us") {
                return `${curDate.month}/${curDate.day}`;
            }
            return `${curDate.month}.${curDate.day}`;
        }

        const printDateHour = (data) => {
            const curDate = formatLocalDateTime(data.hourAsLocalTimeHour);

            if(data.language == "us") {
                if(curDate.hour > 12) {
                    let hour = Number(curDate.hour) - 12
                    return hour.toString() + ":" + curDate.minute + " PM"
                } else {
                    let hour = Number(curDate.hour)
                    hour = hour == 0 ? 12 : hour
                    return hour + ":" + curDate.minute + " AM"
                }
            }
            return `${curDate.hour}.${curDate.minute}`;
        }

        const tableRow = (itemData) => {
            const wind = itemData.wind;

            return `<div class="box-forecast48__list-row">
                <div class="c-item__date-time">
                    <span>${printDateDay(itemData)}</span>
                    <span>${printDateHour(itemData)}</span>
                </div>

                <div class="c-item__charts">
                    <div class="c-chart ${(isChartBarActive(itemData.rain)) ? 'c-chart--active' : ''} c-chart--rain">
                        ${printChartBar(itemData.rain, rainUnit)}
                    </div>

                    <div class="c-chart ${(isChartBarActive(itemData.snow)) ? 'c-chart--active' : ''} c-chart--snow">
                        ${printChartBar(itemData.snow, snowUnit)}
                    </div>
                </div>

                <div class="c-item__temp">
                    <span class="c-temp__icon c-icon--${itemData.icon}"></span>
                    <span class="c-temp__value">
                        ${itemData.temperature}<sup>&#176;${data.temperatureUnit}</sup>
                    </span>
                </div>

                <div class="c-item__wind">
                    <div class="c-wind__icon" style="transform: rotate(${itemData.windBearing}deg);"></div>
                    <div class="c-wind__value">${itemData.wind} ${windUnit}</div>
                </div>
            </div>`
        };

        let content = '';

        hours.forEach((itemData) => {
            content += tableRow(itemData);
        });

        document.querySelector('.box-forecast48__list').innerHTML = content;
    }

    fetch(getApiUrl())
        .then(response => {
            return response.json();
        })
        .then(data => {
            console.debug(`Fetched data from from API (${getApiUrl()}).`, data);
            drawTableData(data);
        })
        .catch(err => {
            console.error(`Can not fetch data from API (${getApiUrl()}).`, err);
        });
}
